import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
} from '@angular/core';

import { ExternalLinkComponent } from '../../../external-link/components/external-link/external-link.component';

@Component({
  selector: 'app-payu-privacy-policy',
  imports: [ExternalLinkComponent],
  templateUrl: './payu-privacy-policy.component.html',
  styleUrl: './payu-privacy-policy.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayuPrivacyPolicyComponent {
  protected readonly readMore = signal(false);
  /* prettier-ignore */
  protected readonly readMoreLabel = computed(() => this.readMore() ?  'Pokaż mniej' : 'Pokaż więcej')

  public handleReadMoreClick(): void {
    this.readMore.update((result) => !result);
  }
}
